var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.698 23.6342L33.3385 16.0811H31.7649L25.9989 22.6393L21.3937 16.0811H16.082L23.0461 25.9983L16.082 33.9189H17.6557L23.7447 26.9932L28.6082 33.9189H33.9199L26.6976 23.6342H26.698ZM24.5426 26.0857L23.837 25.0981L18.2227 17.2402H20.6398L25.1706 23.5818L25.8762 24.5693L31.7657 32.8124H29.3486L24.5426 26.0861V26.0857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.a0c1126729b27e8ffaabc7fb06562cfa.svg";
export { ForwardRef as ReactComponent };